export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'primary' | 'accent' | 'warn';
  icon?: string;
}

export const CONFIRM_PRESETS = {
  unsavedChanges: {
    title: 'Unsaved Changes',
    message: 'You have unsaved changes. Are you sure you want to leave this page?',
    confirmText: 'Leave',
    cancelText: 'Stay',
    confirmColor: 'warn' as const,
    icon: 'warning',
  },
  delete: {
    title: 'Confirm Delete',
    message: 'Are you sure you want to delete this item? This action cannot be undone.',
    confirmText: 'Delete',
    cancelText: 'Cancel',
    confirmColor: 'warn' as const,
    icon: 'delete',
  },
  discard: {
    title: 'Discard Changes',
    message: 'Are you sure you want to discard your changes?',
    confirmText: 'Discard',
    cancelText: 'Keep Editing',
    confirmColor: 'warn' as const,
    icon: 'undo',
  },
} as const;

export type ConfirmPresetKey = keyof typeof CONFIRM_PRESETS;
